/* Momoria — build-your-own gift box.
   The cart does NOT depend on this file: the choices are real radio inputs inside the
   product form, so a submit carries them even if this never runs. Selected styling is
   pure CSS (input:checked + .mgb__optcard). All this does is mirror the current choice
   into the summary and announce it. */
(function () {
  function init(root) {
    if (!root || root.dataset.mgbReady) return;
    root.dataset.mgbReady = '1';

    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var live = root.querySelector('[data-mgb-live]');

    function paint(group) {
      var picked = root.querySelector('[data-mgb-group="' + group + '"]:checked');
      if (!picked) return;

      var name = root.querySelector('[data-mgb-name="' + group + '"]');
      var shot = root.querySelector('[data-mgb-shot="' + group + '"]');
      var note = root.querySelector('[data-mgb-note="' + group + '"]');

      if (name) name.textContent = picked.value;
      if (note) note.textContent = picked.dataset.note || '';
      if (shot) {
        if (picked.dataset.photo) {
          shot.src = picked.dataset.photo;
          shot.hidden = false;
        } else {
          shot.hidden = true;
        }
      }
    }

    function announce(group) {
      if (!live) return;
      var picked = root.querySelector('[data-mgb-group="' + group + '"]:checked');
      if (picked) live.textContent = picked.value + ' selected.';
    }

    ['candle', 'diffuser'].forEach(function (group) {
      qa('[data-mgb-group="' + group + '"]').forEach(function (input) {
        input.addEventListener('change', function () {
          paint(group);
          announce(group);
        });
      });
      paint(group);
    });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mgb]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Theme Editor re-renders the section without a page load */
  document.addEventListener('shopify:section:load', boot);
})();